import { WalkThroughConfig } from '@client-monorepo/shared/common/walk-through';
import { signal } from '@angular/core';

export const HUB_WALKTHROUGH_CONFIG: WalkThroughConfig = {
  background: 'darker',
  baseZIndex: 2000,
  rootElementId: 'hub-walk-through',
  delay: 2500,
  startRoute: '/hub',
  steps: signal([
    {
      id: 1,
      title: 'پرکاربردهای من',
      selectorElement: {
        selector: 'hub-walkthrough',
        selectorType: 'id',
      },
      isFirst: true,
      isLast: true,
      position: 'top',
      description: 'در این بخش، دسترسی سریع به ۴ خدمت پرکاربرد خود دارید و می‌توانید هر زمان با توجه به نیاز خود آنها را ویرایش کنید.',
      isActive: signal(true),
    },
  ]),
};
